import { css } from '@emotion/react';
import { MEDIA_QUERY_MOBILE, MStyles } from 'mobile_ui/MStyles';
import { UIColorPalette } from './ColorPalette';

export default function LobbyButton(props: {
  className?: string;
  children: React.ReactNode;
  onClick?: React.DOMAttributes<HTMLButtonElement>[`onClick`];
  secondary?: boolean;
}) {
  return (
    <button
      className={props.className}
      css={[
        LobbyButtonStyles.button,
        props.secondary ? LobbyButtonStyles.secondary : null,
      ]}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

export const LobbyButtonStyles = {
  button: css(
    {
      backgroundColor: UIColorPalette.buttonPrimary,
      paddingLeft: 50,
      paddingRight: 50,
      minWidth: 160,
      marginLeft: 10,
      marginRight: 10,
      borderRadius: 2,
      border: 'none',
      borderBottom: `2px solid ${UIColorPalette.buttonPrimaryBorder}`,
      outline: 'none',
      '&:hover': {
        backgroundColor: UIColorPalette.buttonPrimaryHover,
        borderColor: UIColorPalette.buttonPrimaryHoverBorder,
      },
      '&:active': {
        backgroundColor: UIColorPalette.buttonPrimaryActive,
        borderColor: UIColorPalette.buttonPrimaryActiveBorder,
      },
      color: UIColorPalette.buttonPrimaryText,

      [MEDIA_QUERY_MOBILE]: {
        padding: 4,
        paddingLeft: 20,
        paddingRight: 20,
        minWidth: 0,
        border: 'none',
      },

      textDecoration: 'none',
    },
    MStyles.touchableMatch,
  ),
  secondary: css({
    color: UIColorPalette.buttonSecondaryText,
    backgroundColor: UIColorPalette.buttonSecondary,
    borderColor: UIColorPalette.buttonSecondaryBorder,
    '&:hover': {
      backgroundColor: UIColorPalette.buttonSecondaryHover,
      borderColor: UIColorPalette.buttonSecondaryHoverBorder,
    },
    '&:active': {
      backgroundColor: UIColorPalette.buttonSecondaryActive,
      borderColor: UIColorPalette.buttonSecondaryActiveBorder,
    },
  }),
};
